'use client'

import { useEffect } from 'react'

import { isDev } from '@/shared/env'

export function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return

    if (isDev) {
      // Dev + Turbopack: SW bisa cache shell lama dan memicu reload loop saat chunk HMR berubah.
      void navigator.serviceWorker.getRegistrations().then((regs) => {
        for (const reg of regs) void reg.unregister()
      })
      return
    }

    void navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // SW opsional — app tetap jalan tanpa install
    })
  }, [])

  return null
}
